import { createNanoEvents } from 'nanoevents'
export default createNanoEvents();
